












































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import { domain, Company, Branch, Terminal, TerminalDataResponse, VueRoot } from "@/domain";
import DatePicker from "@/components/DatePicker.vue";
import QuickSnack from "@/components/QuickSnack.vue";
import * as util from "@/util";
import * as uiUtil from "@/uiUtil";
import * as excel from "@/util/excel";
import * as download from "@/util/download";

interface StatusItem {
  time: string;
  latency: number;
  pinpads: number;
}

@Component({
  components: { DatePicker, QuickSnack }
})
export default class ConnectionStatus extends Vue {
  error = "";
  isLoading = false;
  errorSnack = "";
  loadingFile = "";
  filterPanel = true;

  // Filter variables
  txtDate = util.isoDateString();
  selBranch?: Branch | null = null;
  selTerminal?: Terminal | null = null;

  // Result variables
  statuses: StatusItem[] = [];
  lastResult: TerminalDataResponse | null = null;
  lastFilters: QueryData | null = null;

  headers = [
    {
      text: this.lang.hour,
      align: "left",
      value: "time"
    },
    {
      text: this.lang.latency,
      align: "center",
      value: "latency"
    },
    {
      text: this.lang.devices,
      align: "center",
      value: "pinpads"
    }
  ];

  get lang() {
    return this.$store.state.lang.data;
  }

  get currentCompany(): Company | null {
    return this.$store.state.selectedCompany;
  }

  get isMobile(): boolean {
    return (this.$root as VueRoot).isMobile;
  }

  get currentBranches(): Branch[] {
    return uiUtil.branchComboItems(this.currentCompany, this.$store.getters.userPermission);
  }

  get isValid(): boolean {
    return !!this.selBranch && !!this.selTerminal && !!this.txtDate;
  }

  get currentTerminals(): Terminal[] {
    if (!this.selBranch || !this.selBranch.terminals || this.selBranch.terminals.length === 0) {
      return [];
    }
    return this.selBranch.terminals;
  }

  @Watch("currentBranches")
  onBranchesChanged(newValue: Branch[] | undefined) {
    this.clearData();
    if (!newValue || newValue.length === 0) {
      this.selBranch = null;
      this.selTerminal = null;
    } else {
      this.selBranch = newValue[0];
    }
    this.filterPanel = true;
  }

  @Watch("currentTerminals")
  onTerminalsChanged(newValue: Terminal[] | undefined) {
    this.clearData();
    if (!newValue || newValue.length === 0) {
      this.selTerminal = null;
    } else {
      this.selTerminal = newValue[0];
    }
  }

  created() {
    if (this.$route.query && this.$route.query.branchID && this.$route.query.terminalID) {
      this.$nextTick(() => {
        const selb = this.currentBranches.find((branch) => branch.id === util.toNumber(this.$route.query.branchID));
        this.selBranch = selb;
        if (this.selBranch) {
          this.$nextTick(() => {
            const selt = this.currentTerminals.find((term) => term.code === this.$route.query.terminalID);
            this.selTerminal = selt;
          });
        }
      });
    } else {
      if (this.currentBranches.length > 0) {
        this.selBranch = this.currentBranches[0];
      }
    }
  }

  getFilename(): string {
    return `${this.lang.conectionState} ${this.lastFilters?.branch?.name} (${this.lastFilters?.terminal?.name}) ${this.lastFilters?.date}`;
  }

  async cmdExportExcel() {
    if (this.lastFilters && this.statuses) {
      this.loadingFile = "excel";
      const headers = [
        excel.header(this.lang.hour, "time", 15),
        excel.header(this.lang.latency, "latency", 20),
        excel.header(this.lang.devices, "pinpads", 20)
      ];
      const data = this.statuses.map((stat) => ({ ...stat }));
      try {
        await excel.writeSpreadsheet(this.getFilename(), this.lang.connectionStates, headers, data);
      } catch (err) {
        util.logError("Error escribiendo excel", err);
        this.errorSnack = this.lang.errorGeneratingFile;
      }
      this.loadingFile = "";
    }
  }

  cmdExportPDF() {
    if (this.lastFilters && this.lastResult && this.lastResult.file) {
      this.loadingFile = "pdf";
      const file = this.lastResult.file;
      download.exportBase64(this.getFilename(), file.mimeType, file.base64Data);
      this.loadingFile = "";
    }
  }

  clearData() {
    this.statuses = [];
    this.lastResult = null;
    this.error = "";
  }

  async filterList() {
    if (!this.currentCompany || !this.selBranch || !this.selTerminal) {
      this.error = this.lang.selectParametersToFilter;
      return;
    }
    this.isLoading = true;
    this.error = "";
    try {
      const result = await domain.backend.getTerminalData(
        this.currentCompany.id,
        this.selBranch.id,
        Number(this.selTerminal.code),
        this.selTerminal.tcod,
        this.txtDate
      );
      this.statuses = result.terminalStatuses;
      for (const st of this.statuses) {
        const idx = st.time.indexOf(":");
        if (idx > 0 && idx < 2) {
          st.time = "0" + st.time; // Attach '0' for hours from 1 to 9
        }
      }
      this.lastResult = result;
    } catch (err) {
      util.logError("Error filtering connection status", err);
      this.statuses = [];
      this.lastResult = null;
      this.error = this.lang.errorFilteringResults;
    }
    this.isLoading = false;
    this.lastFilters = {
      company: this.currentCompany,
      branch: this.selBranch,
      terminal: this.selTerminal,
      date: this.txtDate
    };
    this.filterPanel = false;
  }
}
interface QueryData {
  company: Company | null;
  branch?: Branch;
  terminal?: Terminal;
  date: string;
}
